import { useShowCause } from 'core/Api';
import { CauseLogo } from 'core/Components';
import { useCrowdFundingTranslations } from 'core/Hooks';
import { useAtomValue } from 'jotai';
import { Center, Group, Skeleton, Text, Title } from 'ui';

import { donationCauseIdAtom } from '../../Context/donations/donationsCheckout.provider';

export const CauseDescription = () => {
  const donationCauseId = useAtomValue(donationCauseIdAtom);

  const { data: cause, isLoading } = useShowCause(donationCauseId);
  const { t } = useCrowdFundingTranslations(donationCauseId);

  return (
    <div className="cause-description_container w-full">
      <Group align={'center'} justify="flex-start" pb={'xl'} gap="xl" wrap="nowrap">
        <CauseLogo size="lg" cause_uuid={donationCauseId} />

        <Center>
          <Skeleton visible={isLoading} radius={4}>
            <Title order={1} c="white">{`${t('Donate')} to ${cause?.name}`}</Title>
          </Skeleton>
        </Center>
      </Group>

      <div className="cause-description_content">
        <Skeleton visible={isLoading} radius={4}>
          <Text type="body" c="white" style={{ whiteSpace: 'pre-wrap' }}>
            {cause?.description && cause?.description}
          </Text>
        </Skeleton>
      </div>
    </div>
  );
};
